<template>
	<div class="wrapper form">
		<div v-for="index in financers" :key="index" :class="{ 'bgcolor-turquoise': index % 2 === 0 }">
			<div class="input-wrapper">
				<div class="input__title">{{ financers > 1 ? `${index}.` : null }} Finanszírozó adatai:</div>
				<div class="input__field">
					<CalcElem
						:options="optionsForName"
						type="contracting"
						class="w-50 mobile-width-full"
						name="name"
						@click="handleClick($event, index)"
						:index="index"
					/>
					<CalcElem
						v-for="(field, fIndex) in computedFinancingFields(index, 'creditorDetails')"
						:key="fIndex"
						:options="field"
						type="contracting"
						:class="field.inputClass"
						:name="fIndex"
						:ref="`${fIndex}-${index}`"
						:index="index"
					/>
				</div>
			</div>
			<div class="input-wrapper">
				<div class="input__title">
					{{ financers > 1 ? `${index}.` : null }} Finanszírozási szerződés adatai:
				</div>
				<div class="input__field">
					<CalcElem
						v-for="(field, fIndex) in computedFinancingFields(index, 'lendingDetails')"
						:key="fIndex"
						:options="field"
						type="contracting"
						:class="field.inputClass"
						:index="index"
					/>
				</div>
				<div class="rows w-100 mt-12px" v-if="index === 2">
					<div class="input__delete text-center" @click="deleteFinancer(index)">Eltávolítás</div>
				</div>
			</div>
		</div>
		<div class="input-wrapper">
			<div class="input__more" v-if="financers < 2">
				<span @click="handleAdd">További finanszírozó hozzáadása</span>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import dataPages from '@/mixins/dataPages';
import financing from '@/mixins/financing';

export default {
	mixins: [financing, dataPages],
	data() {
		return {
			insurer: 'generali',
			type: 'financingData',
			financers: 1,
		};
	},
	methods: {
		handleAdd() {
			if (this.financers < 2) {
				this.financers++;
			}
		},
		deleteFinancer() {
			this.financers--;
		},
	},
};
</script>
